import { ReactComponent as AccessAlarmIcon } from './access_alarms.svg'
import { ReactComponent as AddBoxIcon } from './add_box.svg'
import { ReactComponent as CheckCircleIcon } from './check_circle.svg'
import { ReactComponent as DarkModeIcon } from './dark_mode.svg'
import { ReactComponent as DateRangeIcon } from './date_range.svg'
import { ReactComponent as DeleteIcon } from './delete.svg'
import { ReactComponent as EditIcon } from './edit.svg'
import { ReactComponent as ExpandLessIcon } from './expand_less.svg'
import { ReactComponent as ExpandMoreIcon } from './expand_more.svg'
import { ReactComponent as LightModeIcon } from './light_mode.svg'
import { ReactComponent as LogoutIcon } from './logout.svg'
import { ReactComponent as RadioButtonUncheckedIcon } from './radio_button_unchecked.svg'
import { ReactComponent as RemoveCircleIcon } from './remove_circle.svg'

export const AccessAlarm = AccessAlarmIcon
export const AddBoxI = AddBoxIcon
export const CheckCircle = CheckCircleIcon
export const DarkMode = DarkModeIcon
export const DateRange = DateRangeIcon
export const Delete = DeleteIcon
export const Edit = EditIcon
export const ExpandLess = ExpandLessIcon
export const ExpandMore = ExpandMoreIcon
export const LightMode = LightModeIcon
export const Logout = LogoutIcon
export const RadioButtonUnchecked = RadioButtonUncheckedIcon
export const RemoveCircle = RemoveCircleIcon